import axios from "axios";
import { proxyUrl } from "../config";
import { setupInterceptorsTo } from "./Interceptors";
setupInterceptorsTo(axios);


export type TicketSupportData = {
    message: string;
    browserInfo: any;
    screenshot: string | null;
    path: string;
    timestamp: string;
    userIdentity: string;
    formVal: string;
    financialFormVal: string;
};


class TicketSupport {
    public createNewSupportTicket = async (ticket: TicketSupportData): Promise<any> => {
        const url: string = `${proxyUrl}/ticket-support/new`;
        const req = await axios.post(url, ticket);
        return req.data;
    };
}

const TicketSupportService = new TicketSupport();
export default TicketSupportService;